import React, { useRef, useEffect, useState, useCallback } from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import SimplePopup from "./Popup";
import Blur from "react-css-blur";
import "./Table.css"

export default function BasicTable({content}) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{maxWidth: 290}} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Attribute</TableCell>
            <TableCell align="left">Value</TableCell>
            <TableCell align="left">Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from(content).map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              {(row.name == "Annual Probability of Flooding") && <TableCell align="left"><Blur radius={'5px'}><p>XXXX</p></Blur></TableCell> }
              {(row.name != "Annual Probability of Flooding") && <TableCell align="left">{row.value}</TableCell> }
              <TableCell align="left">{row.desc != null && <SimplePopup content={row.desc}></SimplePopup>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}